import { createFileRoute } from '@tanstack/react-router'
import { SuppliersPage } from '@/features/suppliers/suppliers-page'

export const Route = createFileRoute('/_auth/w/$workspaceSlug/suppliers')({
  component: SuppliersRoute,
})

function SuppliersRoute() {
  const { workspaceSlug } = Route.useParams()

  return <SuppliersPage workspaceSlug={workspaceSlug} />
}
